module.exports = __webpack_public_path__ + "img/glass-group-b_mobile.0b7bda78.png";